
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M5.6 0a.8.8 0 00-.77.58l-.608 2.13-2.109-.302a.8.8 0 00-.848.477l-1.2 2.8a.8.8 0 00.17.88L1.668 8 .234 9.434a.8.8 0 00-.129.963l1.6 2.8a.8.8 0 00.827.392l1.695-.282.604 2.113A.8.8 0 005.6 16h4a.8.8 0 00.77-.58l.603-2.113 1.695.282a.8.8 0 00.827-.392l1.6-2.8a.8.8 0 00-.13-.963L13.532 8l1.435-1.434a.8.8 0 00.17-.881l-1.2-2.8a.8.8 0 00-.85-.477l-2.108.301-.61-2.129A.8.8 0 009.6 0h-4zm-.03 3.82l.633-2.22h2.794l.634 2.22a.8.8 0 00.882.572l2.193-.313.745 1.738-1.617 1.617a.8.8 0 000 1.132l1.568 1.568-1.02 1.785-1.85-.308a.8.8 0 00-.901.57L8.997 14.4H6.203l-.634-2.22a.8.8 0 00-.9-.57l-1.85.31-1.021-1.786 1.568-1.568a.8.8 0 000-1.132L1.749 5.817l.745-1.738 2.193.313a.8.8 0 00.882-.572zM7.6 9.6a1.6 1.6 0 110-3.2 1.6 1.6 0 010 3.2zM4.4 8a3.2 3.2 0 116.4 0 3.2 3.2 0 01-6.4 0z"}})])
          )
        }
      }
    